<template>
    <div>
        <limitless-page-header :title="'Reklamation / Returorder'">
            <template #header-elements>
                <limitless-page-header-button url="/returnorders/0" icon="icon-plus3">Ny reklamation</limitless-page-header-button>
            </template>
        </limitless-page-header>

        <div class="content">
            <rednax-datatable :url="'/vue/returnorders'" :columns="table_columns" :filter="table_filter" @updateFilter="table_filter=$event" sort-by="CreatedTS" sort-order="desc" @rowclick="rowClick" history>
                <div class="row">
                    <div class="col" style="max-width: 250px;">
                        <input type="text" v-model="table_filter.search" class="form-control" placeholder="Sök...">
                    </div>
                    <div class="col" style="max-width: 250px;">
                        <vue-select
                            :options="select_years"
                            :reduce="(opt) => opt.id"
                            placeholder="Filtrera på år"
                            v-model="table_filter.year"
                        ></vue-select>
                    </div>
                    <div class="col" style="max-width: 250px;">
                        <vue-select
                            :options="select_statuses"
                            :reduce="(opt) => opt.id"
                            placeholder="Filtrera på status"
                            v-model="table_filter.status_id"
                            label="name"
                        ></vue-select>
                    </div>
                </div>
                <template #cell_items="{ row }">
                    <div v-for="(item, i_index) in row.items" :key="'item-' + row.ReturnOrderID + '-' + i_index" :class="{ 'mb-1': i_index < (row.items.length - 1) }" class="d-flex">
                        {{ item.ProdID }}: {{ item.ProdName }}
                        <div class="ml-auto text-right">
                            <div v-if="item.IsReserved" class="badge badge-success">I lager</div>
                            <div v-if="!item.IsReserved && item.product.isPhasedOut" class="badge badge-danger">Har utgått</div>
                            <div v-else-if="!item.IsReserved && item.product.isNonStockItem" class="badge badge-warning">Beställningsvara</div>
                            <div v-else-if="!item.IsReserved && item.product.isOutOfStock" class="badge badge-danger">Tillfälligt Slut</div>
<!--                            <div v-if="item.product.Stock_future > 0" class="badge badge-success">{{ item.product.Stock_future }} DISPONIBELT</div>-->
<!--                            <div v-else class="badge badge-danger">{{ item.product.Stock_future }} DISPONIBELT</div>-->
                        </div>
                    </div>
                </template>
                <template #cell_products="{ row }">
                    <div v-if="row.products.length > 0">
                        {{ row.products.map((item) => item.ProdID + ': ' + item.ProdName).join(', ') }}
                    </div>
                    <div v-else>
                        {{ row.Product }}
                    </div>
                </template>
                <template #cell_ReturnOrderID="{ row }">
                    <router-link :to="{ name: 'returnorder.edit', params: { id: row.ReturnOrderID } }">{{ row.ReturnOrderID }}</router-link>
                </template>
                <template #cell_StatusID="{ row }">
                    <div class="badge text-white" :class="['bg-' + row.StatusClass]">{{ row.StatusName }}</div>
                </template>
                <template #cell_WantedDeliveryDate="{ row }">
                    <span :class="{ 'font-weight-bold': row.WantedDeliveryDateByCustomer }">{{ row.WantedDeliveryDate }}</span>
                </template>
                <template #cell_CreatedTS="{ row }">
                    {{ formatDateTime(row.CreatedTS).substring(0, 16) }}
                </template>
                <template #cell_checkbox="{ row }">
                    <div class="custom-control custom-checkbox" v-if="row.IsDeliverable">
                        <input type="checkbox" class="custom-control-input" :id="'chk-returnorder-' + row.ReturnOrderID" v-model="selected_orders" :value="row.ReturnOrderID">
                        <label class="custom-control-label m-0 p-0" :for="'chk-returnorder-' + row.ReturnOrderID"></label>
                    </div>
                    <div v-else class="text-center">-</div>
                </template>
            </rednax-datatable>
            <div class="text-right">
                <limitless-button ref="btnPrintLabels" btn-class="btn-warning" type="button" @click="btnPrintLabels" icon="icon-printer" :disabled="selected_orders.length <= 0">Skriv ut FRAKTSEDLAR</limitless-button>
            </div>
        </div> <!-- /content -->
    </div>
</template>

<script>
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import LimitlessPageHeaderButton from '@components/Layout/partials/LimitlessPageHeaderButton';
import RednaxDatatable from '@components/Datatable/RednaxDatatableComponent';
import { formatDateTime } from '@services/Helpers';
import LimitlessButton from '@components/Limitless/LimitlessButton.vue';
import apiClient from '@services/ApiClient';
import VueSelect from '@components/Wrappers/VueSelect.vue';

export default {
    name: 'ProductIconList',
    components: {
        VueSelect,
        LimitlessButton,
        LimitlessPageHeader,
        LimitlessPageHeaderButton,
        RednaxDatatable,
    },
    data: () => ({
        current_year: 2023,
        statuses: [],
        selected_orders: [],
        table_filter: {
            search: '',
            per_page: 25,
            year: null,
            status_id: 'active',
        },
        table_columns: [
            {
                header: '#',
                data: 'ReturnOrderID',
                sortable: true,
            },
            {
                header: 'Status',
                data: 'StatusID',
                sortable: true,
            },
            {
                header: 'Kortnummer',
                data: 'CardNo',
                sortable: true,
            },
            {
                header: 'Inlöst av',
                data: 'Name',
                sortable: true,
            },
            // {
            //     header: 'Ort',
            //     data: 'City',
            //     sortable: true,
            // },
            {
                header: 'Kund',
                data: 'CompanyName',
                sortable: true,
            },
            {
                header: 'Rekl. produkt',
                data: 'products',
                sortable: false,
            },
            {
                header: 'Leverans',
                data: 'items',
                sortable: false,
            },
            {
                header: 'Anledning',
                data: 'ResendReason',
                sortable: true,
            },
            {
                header: 'Retur',
                data: 'RequestReturn',
                sortable: true,
            },
            {
                header: 'Datum',
                data: 'CreatedTS',
                sortable: true,
            },
            {
                header: 'Önskad Lev.',
                data: 'WantedDeliveryDate',
                sortable: true,
                class(row) {
                    if (row.WantedDeliveryDate) {
                        const date = new Date();
                        const delDate = new Date(row.WantedDeliveryDate.replace(' ', 'T'));
                        if (delDate.getTime() < date.getTime()) {
                            return 'text-danger';
                        }
                    }
                    return '';
                },
            },
            {
                header: 'Registrerad av',
                data: 'CreatedByName',
                sortable: true,
            },
            {
                header: '',
                data: 'checkbox',
                sortable: false,
                class(row) {
                    let classList = 'noclick';
                    if (row.IsDeliverable) {
                        const date = new Date();
                        const delDate = new Date(row.WantedDeliveryDate.replace(' ', 'T'));
                        if (row.WantedDeliveryDateByCustomer && date.getTime() < (delDate.getTime() - (60 * 24 * 3))) {
                            classList += ' bg-warning-200';
                        } else {
                            classList += ' bg-success-200';
                        }
                    } else {
                        classList += ' bg-danger-200';
                    }
                    return classList;
                },
            },
        ],
    }),
    mounted() {
        const date = new Date();
        this.current_year = date.getFullYear();
        apiClient.get('/vue/returnorders/statuses/list').then((response) => {
            this.statuses = response.data.data;
        });
    },
    methods: {
        formatDateTime,
        rowClick(data, event) {
            if (event.metaKey === true || event.ctrlKey === true) {
                const route = this.$router.resolve({ name: 'returnorder.edit', params: { id: data.ReturnOrderID } });
                window.open(route.href, '_blank').focus();
            } else {
                this.$router.push({ name: 'returnorder.edit', params: { id: data.ReturnOrderID } });
            }
        },
        btnPrintLabels() {
            let url = '/batch/list?type=return_order&status_id=0';
            this.selected_orders.forEach((oid) => {
                url += '&ids[]=' + oid;
            });

            window.location.href = url;
        },
    },
    computed: {
        old_system_url() {
            return window.config.app.old_system_url;
        },
        select_years() {
            const today = new Date();
            const years = [];
            // eslint-disable-next-line no-plusplus
            for (let i = today.getFullYear(); i >= 2008; i--) {
                years.push({
                    id: i,
                    label: i,
                });
            }
            return years;
        },
        select_statuses() {
            const statuses = [...this.statuses];
            statuses.unshift({
                id: '---',
                name: '------',
                disabled: true,
            });
            statuses.unshift({
                id: 'active',
                name: 'Aktiva',
            });
            return statuses;
        },
    },
};

</script>
